import Division from '../../components/Division'
import Fragment from '../../components/Fragment'

const Intro = ({ classes, post, fragments }) => (
  <Grid item xs={12} md={7} lg={6} className={classes.content}>
    <Typography variant="h4" align="center">
      {post ? 'One last thing...' : 'Make a change'}
    </Typography>
    <Division padding={20} />
    <Typography variant="body1" align="left">
      <Fragment {...{ fragments }} title="donate_cta_text" />
    </Typography>
  </Grid>
)

export default Intro
